module.exports = __webpack_public_path__ + "images/img-1m_2Egx.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/ranks/1.jpg
// module id = 2028
// module chunks = 0